"use strict";
var React = require("react");
var { Component } = React;
var PropTypes = require("prop-types");

const Toggleable = (WrappedComponent, defaultState = false) => {
    return class extends Component {
        constructor(...args) {
            super(...args);
            this.state = {
                toggled: defaultState
            };
        }

        onToggle = () => {
            const {
                onToggle
            } = this.props;

            this.setState({toggled: !this.state.toggled});

            if (onToggle) {
                onToggle(!this.state.toggled);
            }
            return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        resolve(this.state.toggled);
                        this.props.handleToggle(this.state.toggled);
                    }, 0);
                }
            );
        };

        UNSAFE_componentWillReceiveProps(nextProps) {
            if (typeof(nextProps.toggled) !== 'boolean') {
                return;
            }

            let {
                toggled
            } = this.state;

            if (toggled !== nextProps.toggled) {
                this.onToggle();
            }
        }

        render() {
            const ToggleTarget = (props) => (
                <div {...props} onClick={this.onToggle}>
                    {props.children}
                </div>
            );
            const ToggleArea = (props) => (
                <div {...props}>
                    {this.state.toggled ? props.children : false}
                </div>
            );
            const newProps = {
                toggled: this.state.toggled,
                onToggle: this.onToggle,
                ToggleTarget,
                ToggleArea
            };

            return <WrappedComponent {...this.props} {...newProps} />;
        }
    };
};

Toggleable.propTypes = {
    handleToggle: PropTypes.func
};
Toggleable.defaultProps = {
    handleToggle: () => {}
};

module.exports = Toggleable;